import { Flex } from "@rebass/grid";
import styled from "styled-components";

export const LoginOktaWrapper = styled.div`
    .auth-container {
        margin: 0 auto !important;
        border: none !important;
        box-shadow: none !important;
        background-color: transparent !important;
        font-family: Poppins, sans-serif !important;
        z-index: 2;
        padding: 0 !important;
        
        .okta-sign-in-header,
        .okta-form-title {
            display: none;
        }

        input[type='text'],
        input[type='password'] {
          font-family: Poppins !important;
        }

        .focused-input,
              input[type='text']:focus,
              input[type='password']:focus,
              input[type='submit']:focus {
                border: 1px solid #E4E7EC !important;
                box-shadow: inset 1px 2px 2px rgba(16, 24, 40, 0.12) !important;
                border-radius: 4px !important;
              }
              
        .focused-input,
            input[type='checkbox']:focus {
                border: unset !important;
                box-shadow: unset !important;
            }
        
        label {
            color: #667085;
        }

        .link {
            color: #7B73E4 !important;
            transition: 0.5s !important;
        }

        .o-form-label {
            text-align: left;
        }

        .custom-checkbox label {
            margin-top: -20px !important;
            text-align: left;
            color:  #101828;
        }
        
        .button {
            background: #6250ED !important;
            color: white;
            transition: 0.5s !important;
            :hover {
                background: #4634D0 !important;
            }
        }

        input[type='submit'] {
            font-family: inherit !important;
            font-weight: 500 !important;
            line-height: 1.75 !important;
            height: unset !important;
            padding: 6px 1rem !important;
            border: 1px solid #E4E7EC !important;
            box-shadow: inset 1px 2px 2px rgba(16, 24, 40, 0.12) !important;
            border-radius: 4px !important;

            &.email-button {
               margin-top: 2rem !important;
            }
        }
    }
`;


export const LoginBanner = styled(Flex)`
    font-size: 14px;
    background-color: #6351ed;
    color: #fff;
    width: 100%;
    padding: 10px;
    justify-content: center;
`;